import baseStyles from '../Base/Base.styles'

export default ({
  base,
  borderColor,
  bgColor,
  labelColor,
  dateColor,
  display,
 }) => {
  let jss = {
    root: {
      ...baseStyles(base),
      padding: '48px',
      display: 'grid',
      gridGap: '32px',
      gridTemplateColumns: display.map((e) => '1fr').join(' '),
      textAlign: 'center',

      '& .item': {
        border: `2px solid ${borderColor}`,
        borderRadius: "var(--themeShape)",
        padding: '20px',
        backgroundColor: bgColor
      },

      '& .time': {
        color: dateColor,
        fontSize: '32px'
      },

      '& .label': {
        color: labelColor,
        fontSize: '16px',
        fontWeight: '400',
        marginTop: '10px'
      }
    }
  }

  return jss
}
